import { NgModule } from "@angular/core";
import { LoginPage } from "./login";
import { CommonModule } from "@angular/common";
import { IonicPageModule } from "ionic-angular";
import { LoginRoutingModule } from "./login-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../modules-shared/shared.module";
import { ControlMessageModule } from "../../modules-other/control-message/control-messages.module";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        IonicPageModule.forChild(LoginPage),
        SharedModule,
        LoginRoutingModule,
        ControlMessageModule
    ],
    declarations: [
        LoginPage
    ],
    entryComponents: [
        LoginPage
    ]
})
export class LoginPageModule {

}



// WEBPACK FOOTER //
// ./src/vas/pages/login/login.module.ts